import create from 'zustand'
import * as THREE from "three"
import { createRef } from 'react'

const useStore = create(set => ({
  top: 0,
  scrollTop: createRef(),
  lang: new URLSearchParams(window.location.search).get("lang") == 'en' ? 0 : 1,
  initial: true,
  audioPlay: false,
  actions: {
    changeTop: (value) => set(state => ({ top: THREE.MathUtils.lerp(state.top, value, window.innerWidth > 768 ? 0.04 : 0.08) })),
  }
}))

export default useStore